import React from "react";
import Text from "../Text";

const TextWithEmail = (props) => {
    return <Text as="p" content={props.text + props.email}></Text>
}

export default TextWithEmail;